<nb-card class="agent-token-dialog">
  <nb-card-header>
    <h4>{{ (created ? 'pages.settings.agentAccess.dialog.createdTitle' : 'pages.settings.agentAccess.dialog.title') | translate }}</h4>
  </nb-card-header>

  @if (!created) {
    <nb-card-body>
      <form [formGroup]="form" class="agent-token-dialog__form" (ngSubmit)="submit()">
        <label class="label" for="agent-token-name">{{ 'pages.settings.agentAccess.dialog.name' | translate }}</label>
        <input
          id="agent-token-name"
          nbInput
          fullWidth
          formControlName="name"
          [placeholder]="'pages.settings.agentAccess.dialog.namePlaceholder' | translate"
        />

        <label class="label" for="agent-token-lifetime">{{ 'pages.settings.agentAccess.dialog.lifetime' | translate }}</label>
        <nb-select id="agent-token-lifetime" fullWidth formControlName="expires_in_days">
          @for (days of lifetimes; track days) {
            <nb-option [value]="days">{{ 'pages.settings.agentAccess.dialog.days' | translate: { days: days } }}</nb-option>
          }
        </nb-select>

        <div class="agent-token-dialog__toggle">
          <nb-toggle formControlName="can_write" status="primary">
            {{ 'pages.settings.agentAccess.dialog.canWrite' | translate }}
          </nb-toggle>
          <p class="agent-token-dialog__hint">{{ 'pages.settings.agentAccess.dialog.canWriteHint' | translate }}</p>
        </div>
      </form>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton status="basic" type="button" (click)="close()">{{ 'buttons.cancel' | translate }}</button>
      <button nbButton status="primary" type="button" [nbSpinner]="saving" [disabled]="saving" (click)="submit()">
        {{ 'pages.settings.agentAccess.dialog.create' | translate }}
      </button>
    </nb-card-footer>
  } @else {
    <nb-card-body>
      <p class="agent-token-dialog__once">{{ 'pages.settings.agentAccess.dialog.onlyOnce' | translate }}</p>
      <div class="agent-token-dialog__token">
        <code>{{ created.token }}</code>
        <button nbButton size="small" status="basic" type="button" (click)="copy(created.token || '')">
          <nb-icon icon="copy-outline"></nb-icon>{{ 'pages.settings.agentAccess.copy' | translate }}
        </button>
      </div>

      <p class="label">{{ 'pages.settings.agentAccess.dialog.setup' | translate }}</p>
      <nb-tabset>
        @for (kind of clients; track kind) {
          <nb-tab [tabTitle]="'pages.settings.agentAccess.clients.' + kind | translate">
            <p class="agent-token-dialog__hint">{{ 'pages.settings.agentAccess.clientHints.' + kind | translate }}</p>
            <pre class="agent-token-dialog__snippet">{{ snippet(kind) }}</pre>
            <button nbButton size="small" status="basic" type="button" (click)="copy(snippet(kind))">
              <nb-icon icon="copy-outline"></nb-icon>{{ 'pages.settings.agentAccess.copy' | translate }}
            </button>
          </nb-tab>
        }
      </nb-tabset>
    </nb-card-body>
    <nb-card-footer>
      <span></span>
      <button nbButton status="primary" type="button" (click)="close()">{{ 'pages.settings.agentAccess.dialog.done' | translate }}</button>
    </nb-card-footer>
  }
</nb-card>
